module.exports = " <span>{{startVal}}</span> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/countup/index.vue
// module id = 217
// module chunks = 2